import { FC } from 'react';
import { Tab } from '~/application/components/Tab/Tab';
import { Alert } from '~/application/components/Alert/Alert';
import { Avatar } from '~/application/components/Avatar/Avatar';
import { SponsorRequestWidget } from '~/domain/sponsor/components/SponsorRequestWidget/SponsorRequestWidget';
import { Container } from '~/application/components/Container/Container';
import { Content } from '~/application/components/Content/Content';
import { useUserLayout, Props } from './useUserLayout';
import styles from './UserLayout.module.css';

export const UserLayout: FC<Props> = (props) => {
  const { user, loginUser, avatar, tabs, children } = useUserLayout(props);

  return (
    <Content top={false}>
      <div
        className={styles.wrapper}
        style={{
          ...(user.cover && { backgroundImage: `url(${user.cover?.url})` })
        }}>
      </div>
      <div className={styles.contents}>
        <Container>
          <div className={styles.row}>
            <div className={styles.main}>
              <div className={styles.header}>
                <div className={styles.user}>
                  <Avatar src={avatar} size="xl" />
                  <div className={styles.name}>{user.name}</div>
                </div>
                <div className={styles.summary}>{user.summary}</div>
              </div>
              <div className={styles.nav}>
                <Tab items={tabs} />
              </div>
              <div>{children}</div>
            </div>
            <aside className={styles.side}>
              {user.isReceiveSponsor &&
              <SponsorRequestWidget user={user} loginUser={loginUser} />}

              {!user.isReceiveSponsor &&
              <Alert theme="info">
                  {user.name}さんは現在スポンサーを募集していません。
                </Alert>}

            </aside>
          </div>
        </Container>
      </div>
    </Content>);

};